import { ImageProps as SemanticImageProps } from 'semantic-ui-react'
import { ImageWrapper, StyledImage, EditIcon } from './Styles'
import Avatar from './Avatar'

interface ImageProps extends SemanticImageProps {
  editable?: boolean
  onEdit?: () => void
  name?: string
}

const Image = ({ editable, onEdit, ...rest }: ImageProps) => {
  if (!editable) {
    return <StyledImage {...rest} />
  }

  return (
    <ImageWrapper>
      <EditIcon onClick={onEdit} />
      <StyledImage {...rest} />
    </ImageWrapper>
  )
}

Image.Avatar = Avatar

export default Image
